
import { 
    ADD_TEAM_MEMBER,
    UPDATE_TEAM_MEMBER,
    DELETE_TEAM_MEMBER,
    PROPERTIES_UNITS_FETCH_INITIAL_DATA,
    FETCH_TEAM,
    LOG_OUT_USER
} from '../../actions/actionTypes';


const addTeamReducer = (team, payload) => {
    let newTeamMembers = { ...team };
    newTeamMembers[payload.personId] = {
        ...payload
    }
    
    return newTeamMembers;   
}

const updateTeamReducer = (team, payload) => {
    let newTeamMembers = {...team};
    newTeamMembers[payload.personId] = { ...payload };
    return newTeamMembers;
}

const deleteTeamReducer = (team, payload) => {
    let newTeamMembers = {...team};
    delete newTeamMembers[payload.personId];
    return newTeamMembers;
}


const teamReducer = (state={}, action) => {
    let team = state;
    if (action.errors == null){
        switch(action.type){
            case PROPERTIES_UNITS_FETCH_INITIAL_DATA:
                return action.payload.team;
            case ADD_TEAM_MEMBER:
                return addTeamReducer(team, action.payload);
            case UPDATE_TEAM_MEMBER:
                return updateTeamReducer(team, action.payload);
            case DELETE_TEAM_MEMBER:
                return deleteTeamReducer(team, action.payload);
            case FETCH_TEAM:
                return action.payload.person
            case LOG_OUT_USER:
                return {};
            default:
                return team; 
        }
    }else{
        return team;
    }
};
export default teamReducer;